import React from "react";

function ModalCredits({ lang }) {
  if (lang === "en") {
    return (
      <div className="window-content en">
        <h2>HOW TO CITE</h2>
        <p>Loporcaro Michele, Donzelli Giulia, Gasner Lisa, Idone Alice, Negrinelli Stefano, Pescarini Diego, Salvi Adriano, Schmid Stephan, Tisato Graziano &amp; Zanini Chiara. 2026. <em>AIS, reloaded: A Complete, Searchable Edition with a New Dialect Atlas of Southern Switzerland and Lombardy</em>. University of Zurich. Available online at <a href="https://www.ais-reloaded.uzh.ch">https://www.ais-reloaded.uzh.ch</a>.</p>
      </div>
    );
  } else if (lang === "it") {
    return (
      <div className="window-content it">
        <h2>COME CITARE</h2>
        <p>Loporcaro Michele, Donzelli Giulia, Gasner Lisa, Idone Alice, Negrinelli Stefano, Pescarini Diego, Salvi Adriano, Schmid Stephan, Tisato Graziano &amp; Zanini Chiara. 2026. <em>AIS, reloaded: A Complete, Searchable Edition with a New Dialect Atlas of Southern Switzerland and Lombardy</em>. Università di Zurigo. Consultabile in rete sul sito <a href="https://www.ais-reloaded.uzh.ch">https://www.ais-reloaded.uzh.ch</a>.</p>
      </div>
    );
  }
  return null;
}

export default ModalCredits;
